angular.module('autoremind.admin.chargify')
    .directive('adminChargifyReconcileSubscriptions', ['chargifyService', 'logger',
    function (chargifyService, logger) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/chargify/admin-chargify-reconcile-subscriptions.html',
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.reconcileFetchStateBusy = false;
                $scope.reconcileSubscriptionsTotalCount = null;
                $scope.reconcileSubscriptionsErrorCount = null;
                $scope.reconcileSubscriptions = [];
                $scope.reconcileSubscriptionsSort = { "column": "updatedInt", "descending": false };
                $scope.reconcileAccountsTotalCount = null;
                $scope.reconcileAccountsErrorCount = null;
                $scope.reconcileAccounts = [];
                $scope.reconcileAccountsSort = { "column": "userModifiedInt", "descending": false };
                $scope.changeSortingAccounts = function (column) {
                    if ($scope.reconcileAccountsSort.column === column) {
                        $scope.reconcileAccountsSort.descending = !$scope.reconcileAccountsSort.descending;
                    }
                    else {
                        $scope.reconcileAccountsSort.column = column;
                        $scope.reconcileAccountsSort.descending = false;
                    }
                };
                $scope.changeSortingSubscriptions = function (column) {
                    if ($scope.reconcileSubscriptionsSort.column === column) {
                        $scope.reconcileSubscriptionsSort.descending = !$scope.reconcileSubscriptionsSort.descending;
                    }
                    else {
                        $scope.reconcileSubscriptionsSort.column = column;
                        $scope.reconcileSubscriptionsSort.descending = false;
                    }
                };
                $scope.fetchSubscriptionsReconcile = function () {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchSubscriptionsReconcile() start');
                    $scope.reconcileFetchStateBusy = true;
                    $scope.reconcileSubscriptionsTotalCount = null;
                    $scope.reconcileSubscriptionsErrorCount = null;
                    $scope.reconcileSubscriptions = [];
                    $scope.reconcileAccountsTotalCount = null;
                    $scope.reconcileAccountsErrorCount = null;
                    $scope.reconcileAccounts = [];
                    chargifyService.fetchSubscriptionsReconcile()
                        .then(function (data, status) {
                        $scope.reconcileSubscriptionsTotalCount = data.subscriptionsTotalCount;
                        $scope.reconcileSubscriptionsErrorCount = data.subscriptionsErrorCount;
                        $scope.reconcileSubscriptions = data.subscriptions;
                        $scope.reconcileAccountsTotalCount = data.accountsTotalCount;
                        $scope.reconcileAccountsErrorCount = data.accountsErrorCount;
                        $scope.reconcileAccounts = data.accounts;
                        $scope.reconcileFetchStateBusy = false;
                    }, function (data, status) {
                        $scope.status = status;
                        $scope.reconcileFetchStateBusy = false;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchSubscriptionsReconcile() end');
                };
                $scope.customerSetReference = function (customerId, reference) {
                    logger.debug('autoremind.admin.chargify.ScreenController.subscriptioSetReference(' + customerId + ',' + reference + ')');
                    var updateJSON = { "customer": { "reference": reference } };
                    chargifyService.customerSetReference(customerId, updateJSON)
                        .then(function (data, status) {
                        if (data.customer && data.customer.id) {
                            for (var i = 0; i < $scope.reconcileSubscriptions.length; i++) {
                                if (data.customer.id === $scope.reconcileSubscriptions[i].customer.id) {
                                    $scope.reconcileSubscriptions[i].customer = data.customer;
                                    $scope.reconcileSubscriptions[i].errortext = "Customer has been updated.";
                                }
                            }
                        }
                    }, function (data, status) {
                        $scope.status = status;
                    });
                };
                $scope.customerEditReference = function (customerId) {
                    logger.debug('autoremind.admin.chargify.ScreenController.customerEditReference(' + customerId + ')');
                    for (var i = 0; i < $scope.reconcileSubscriptions.length; i++) {
                        if ($scope.reconcileSubscriptions[i].customer.id === customerId) {
                            $scope.reconcileSubscriptions[i].customer.newreference = $scope.reconcileSubscriptions[i].customer.reference;
                            $scope.reconcileSubscriptions[i].customer.reference = "";
                        }
                    }
                };
            }
        };
    }]);
//# sourceMappingURL=admin-chargify-reconcile-subscriptions.js.map